export default function getResource(label, vars = []) {
    const resources = {
        rougeExclusive: 'ROUGE EXCLUSIVE'
    };

    return resources[label];
}
